import React from 'react'
import RouterLink from 'gatsby-link'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import { startsWith, isEmpty, endsWith, includes } from 'lodash'
import sendAffiliateLink from '../../actions/events/sendAffiliateLink'

const Link = (props) => {

	const handleOutboundLink = () => {
		if (includes(props.to, 'banggood')){
			sendAffiliateLink({
				product: props.product || props.to,
				value: props.value
			})
		}
	}

	return (isEmpty(props.to) ? <span {...props}>
		{ props.children }
	</span> : startsWith(props.to, 'http') ? <OutboundLink
			{...props}
	 		href={props.to}
	  	className={props.className}
	 		onClick={handleOutboundLink}
	 		target="_blank" rel="noopener">
		{ props.text || props.children }
	</OutboundLink>: <RouterLink {...props} to={!endsWith(props.to, '/') ? `${ props.to }/`: props.to } className={props.className}>
		{ props.children }
	</RouterLink>)
}
export default Link



// WEBPACK FOOTER //
// ./src/components/Link/index.js